var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewcontact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 10.5L18.6666 7M18.6666 7L22.1666 3.5M18.6666 7L25.6666 7M18.6666 24.5V23.1C18.6666 21.1398 18.6666 20.1597 18.2851 19.411C17.9496 18.7525 17.4141 18.217 16.7556 17.8815C16.0069 17.5 15.0268 17.5 13.0666 17.5H7.93325C5.97307 17.5 4.99298 17.5 4.24429 17.8815C3.58572 18.217 3.05029 18.7525 2.71473 19.411C2.33325 20.1597 2.33325 21.1398 2.33325 23.1V24.5M14.5833 8.75C14.5833 11.0052 12.7551 12.8333 10.4999 12.8333C8.24476 12.8333 6.41659 11.0052 6.41659 8.75C6.41659 6.49484 8.24476 4.66667 10.4999 4.66667C12.7551 4.66667 14.5833 6.49484 14.5833 8.75Z",
    stroke: "#121215",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcontact);
export default __webpack_public_path__ + "static/media/New contact.6691b29f0f6f958223159dd3ac76244d.svg";
export { ForwardRef as ReactComponent };